enum BlogEnum {
  'blog' = 'blog',
  'blog_subtitle' = 'blog_subtitle',
  'latest_blog_posts' = 'latest_blog_posts',
  'you_dont_have_an_account_yet' = 'you_dont_have_an_account_yet',
  'create_it_right_now' = 'create_it_right_now',
  'sign_up_now' = 'sign_up_now',
  'learn_more' = 'learn_more',
  'spiritory_news' = 'spiritory_news',
  'articles_for_enthusiasts' = 'articles_for_enthusiasts',
  'authors' = 'authors',
  'latest_articles' = 'latest_articles',
  'oops_we_couldnt_find_any_articles' = 'oops_we_couldnt_find_any_articles',
  'popular_topics_among_users' = 'popular_topics_among_users',
  'highlights_of_the_month' = 'highlights_of_the_month',
  'all_articles' = 'all_articles',
  'less_articles' = 'less_articles',
  'authors_share_title' = 'authors_share_title',
  'authors_subtitle_1' = 'authors_subtitle_1',
  'authors_subtitle_2' = 'authors_subtitle_2',
  'author_about' = 'author_about',
  'related_blogs' = 'related_blogs',
  'content_table' = 'content_table',
  'spiritory_blog' = 'spiritory_blog',
  'to_the_author' = 'to_the_author',
  'born' = 'born',
  'favorite_whisky' = 'favorite_whisky',
  'nationality' = 'nationality',
  'whiskyEnthusiasticSince' = 'whiskyEnthusiasticSince',
  'articles_by_this_author' = 'articles_by_this_author',
  'magazine_articles_by_this_author' = 'magazine_articles_by_this_author',
  'blog_articles_by_this_author' = 'blog_articles_by_this_author',
  'know_all_authors' = 'know_all_authors',
  'search_placeholder' = 'search_placeholder',
  'search_aria_label_blog' = 'search_aria_label_blog',
  'search_aria_label_magazine' = 'search_aria_label_magazine',
  'no_blogs_found' = 'no_blogs_found',
  'no_magazines_found' = 'no_magazines_found',
  'loading_title' = 'loading_title',
  'blog_thumbnail_alt' = 'blog_thumbnail_alt',
  'magazine_thumbnail_alt' = 'magazine_thumbnail_alt',
  'published' = 'published',
  'by' = 'by',
  'min_read' = 'min_read',
  'follow_on_google_news' = 'follow_on_google_news',
  'follow_on_google_news_description' = 'follow_on_google_news_description',
}

export { BlogEnum };